export const hasResponsibility = (identityUUID, description, relatedModel = null, relatedInstance = null) => {
  if (identityUUID === 'self') {
    let responsibilityArray = JSON.parse(localStorage.getItem('userResponsibilities'))
    if (!responsibilityArray) return false

    return responsibilityArray.find(responsibility =>
      responsibility.node.description === description &&
      (relatedModel ? responsibility.node.relatedModel === relatedModel : true) &&
      (relatedInstance ? responsibility.node.relatedId === relatedInstance : true)
    ) ? true : false
  }
  else {
    // TODO: hit schema when identityUUID not 'self'

    return false
  }
}

export const hasAnyResponsibility = (identityUUID, responsibilities) => (
  !!responsibilities.find(responsibility => (
    hasResponsibility(identityUUID, responsibility.description, responsibility.relatedModel, responsibility.relatedInstance)
  ))
)

export const hasAllResponsibilities = (identityUUID, responsibilities) => (
  responsibilities.every((responsibility) => (
    hasResponsibility(identityUUID, responsibility.description, responsibility.relatedModel, responsibility.relatedInstance)
  ))
)

export const getIdentityResponsibility = (responsibility, model, id) => {
  let identityResponsibilities = JSON.parse(localStorage.getItem('identityResponsibilities'))

  if (identityResponsibilities) {
    if (model && id) {
      return identityResponsibilities.find((identityResponsibility) => (
        identityResponsibility.node.responsibilitytype.name === responsibility &&
        identityResponsibility.node.relatedModel.model === model &&
        identityResponsibility.node.relatedId === id
      ))
    } else if (model) {
      return identityResponsibilities.find((identityResponsibility) => (
        identityResponsibility.node.responsibilitytype.name === responsibility &&
        identityResponsibility.node.relatedModel.model === model
      ))
    } else {
      return identityResponsibilities.find((identityResponsibility) => (
        identityResponsibility.node.responsibilitytype.name === responsibility
      ))
    }
  } else {
    return null
  }
}

export const getIdentityResponsibilities = (responsibility, model, id) => {
  let identityResponsibilities = JSON.parse(localStorage.getItem('identityResponsibilities'))

  if (identityResponsibilities) {
    if (model && id) {
      return identityResponsibilities.filter((identityResponsibility) => (
        identityResponsibility.node.responsibilitytype.name === responsibility &&
        identityResponsibility.node.relatedModel.model === model &&
        identityResponsibility.node.relatedId === id
      ))
    } else if (model) {
      return identityResponsibilities.filter((identityResponsibility) => (
        identityResponsibility.node.responsibilitytype.name === responsibility &&
        identityResponsibility.node.relatedModel.model === model
      ))
    } else {
      return identityResponsibilities.filter((identityResponsibility) => (
        identityResponsibility.node.responsibilitytype.name === responsibility
      ))
    }
  } else {
    return []
  }
}

export const hasAllIdentityResponsibilities = (...responsibilities) => {  // expects array of [responsibility type, related model, related id]
  // is any responsibility of the ones passed into this function not assigned to the user identity?
  let hasUnassignedResponsibility = responsibilities.find((responsibility) => (
    !getIdentityResponsibility(responsibility[0], responsibility[1], responsibility[2])  // getIdentityResponsibility returns 'null'/'undefined' if responsibility not found on identity
  ))

  if (hasUnassignedResponsibility) {
    return false
  } else {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/utils/user/index.js